import { ChatListMode } from "@saysimple-platform/dtos";

export enum StatusFilterNameType {
    NEW = "new",
    TEAM = "team",
    OPEN = "open",
    PERSONAL = "personal",
    ARCHIVE = "archive",
}

export enum StatusType {
    OPEN = "open",
    CLOSED = "closed",
}

export type StoredFilterKey = "teams" | "channels" | "tags" | "labelIds" | "userIds" | "read";
export type FilterKey = StoredFilterKey | "sortBy";

export type FilterType = {
    teams?: number[];
    channels?: number[];
    tags?: number[];
    labelIds?: number[];
    userIds?: number[];
    read?: number[];
    keyword?: string;
    sortBy?: ChatListMode;
};

export type ActiveFilter = FilterType & {
    page: number;
    status: {
        title: string;
        name: StatusFilterNameType;
        query: {
            status: StatusType;
            assignedUserId?: any;
            assignedTeamId?: any;
            channelId?: any;
            keyword?: any;
        };
    };
};
